<app-labels-dropdown
  #labelsDropdown
  class="text-navy-90"
  [ngClass]="{ 'hover:initial': !channelsUsersData }"
  [isDisabled]="!channelsUsersData"
  [searchEnabled]="true"
  [clearSearchOnDropdownClose]="true"
  [labelType]="'secondary'"
  [displayAllSelectedItems]="true"
  [displayEmptyState]="false"
  [selectedData]="selectedData"
  [data]="channelsUsersData"
  [hasAddLabel]="true"
  [buttonTranslationKey]="buildTranslationKey('addBtn')"
  [buttonIcon]="'Add'"
  [idSelector]="channelIdSelector"
  [displayValueSelector]="displayChannelValueSelector"
  [bottomDropdownAction]="bottomDropdownAction"
  (dropdownClose)="editChannels($event)"
></app-labels-dropdown>
